<style scoped>
.bg-darkblue{
    background-color:#003567;
}
.headfont{
    font-size: 20px;
}
@media screen and (max-width:1117px) {
    .headfont{
        font-size: 18px;
    }
}
@media screen and (max-width:1068px) {
    .headfont{
        font-size: 16px;
    }
}
@media screen and (max-width:1018px) {
    .headfont{
        font-size: 14px;
    }
}
.active-bot{
    border-bottom:2px solid #fff;
}
.myheader{
    z-index: 2;
}
</style>
<template>
    <div>
        <header class="myheader navbar navbar-expand-lg navbar-dark bg-darkblue" name="top" id="top">
            <div class="container-fluid">
                <router-link to="/" class="navbar-brand align-middle" style="font-size:26px;">
                    <img src="../assets/images/headlogo.jpg" height="40px" class="d-inline-block align-top mr-2" alt="">冠全資訊
                </router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#head" aria-expanded="false"
                aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                
                <div class="collapse navbar-collapse headfont " id="head">
                    <ul class="navbar-nav navbar-right ml-auto text-center">
                        <li class="nav-item mr-2">
                            <router-link class="nav-link nav-bot" to="/" exact active-class="active active-bot">
                                <img src="../assets/images/icon/home.png?20181011" class="mr-1" alt="">首頁
                            </router-link>
                        </li>
                        <li class="nav-item mr-2" @click="test()">
                            <router-link class="nav-link nav-bot" to="/news" active-class="active active-bot">
                                <img src="../assets/images/icon/NEWS.png?20181011" class="mr-1" alt="">NEWS
                            </router-link> 
                        </li>
                        <li class="nav-item mr-2" >
                            <router-link class="nav-link nav-bot" to="/about" active-class="active active-bot">
                                <img src="../assets/images/icon/about.png?20181011" class="mr-1" alt="">公司簡介
                            </router-link> 
                        </li>
                        <li class="nav-item mr-2 " >
                            <router-link class="nav-link nav-bot" to="/product" active-class="active active-bot">
                                <img src="../assets/images/icon/product.png?20181011" class="mr-1" alt="">產品介紹
                            </router-link> 
                        </li>
                        <li class="nav-item mr-2" >
                            <router-link class="nav-link nav-bot" to="/cooperate" active-class="active active-bot">
                                <img src="../assets/images/icon/cooperation.png?20181011" class="mr-1" alt="">合作夥伴
                            </router-link> 
                        </li>
                        <li class="nav-item mr-2" >
                            <router-link class="nav-link nav-bot" to="/partner" active-class="active active-bot">
                                <img src="../assets/images/icon/case.png?20181011" class="mr-1" alt="">建置實績
                            </router-link>
                        </li>
                        <li class="nav-item mr-2" >
                            <router-link class="nav-link nav-bot" to="/contact" active-class="active active-bot">
                                <img src="../assets/images/icon/contact.png?20181011" class="mr-1" alt="">聯絡我們
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    </div>
</template>

<script>

export default {
    methods:{
        test:function (params) {
            console.log()
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/myheader.vue